module.exports = __webpack_public_path__ + "img/lose.5cb0b72a.png";